<template>
	<div>
		<!-- <top></top> -->
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<el-breadcrumb separator-class="el-icon-minus">
					<el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm">首页</span></el-breadcrumb-item>
					<el-breadcrumb-item><span @click="backmy('myself')" class="text-sm"
							:class="type != 'myself'?'pointer':''">个人中心</span></el-breadcrumb-item>
					<el-breadcrumb-item v-if="type != 'myself'">
						<!-- 展示除个人中心外其他组件 -->
						<span class="text-sm" @click="backmy(typeone)" :class="typeone != ''?'pointer':''"
							v-if="typeone != ''">{{typeone | fiterype}}</span>
						<!-- 是主页面还是子页面 -->
					 <span class="text-sm" v-else>{{type | fiterype}}</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item v-if="typeone != ''">
						<!-- 有子页面 -->
						<span class="text-sm">{{type | fiterype}}</span>
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="flex margin-bottom">
				<!-- 左边列表	 -->
				<MyLeft @gettype="gettype" ref="myleft"></MyLeft>
				<!-- 个人中心 -->
				<MySelt @gettype="gettype" v-if="type == 'myself'"></MySelt>
				<!-- 简历名片 -->
				<Resume v-if="type == 'resume'" @gettype="gettype" @addpro="addpro" @addcer="addcer"></Resume>
				<!-- 编辑基本信息 -->
				<Basic v-if="type == 'basic'"></Basic>
				<!-- 发布招工 -->
				<Release v-if="type == 'release'"></Release>
				<!-- 发布招标 -->
				<Bidding v-if="type == 'bidding'"></Bidding>
				<!-- 招标管理 -->
				<Tender v-if="type == 'tender'" @gettype="gettype"></Tender>
				<!-- 招标管理详情 -->
				<TenderDetail v-if="type == 'tenderdetail'" @gettype="gettype"></TenderDetail>
				<!-- 发布租赁 -->
				<Lease v-if="type == 'lease'"></Lease>
				<!-- 租赁管理 -->
				<Leaselist v-if="type == 'leaselist'" @gettype="gettype"></Leaselist>
				<!-- 租赁管理详情 -->
				<LeaseDetail v-if="type == 'leasedetail'"></LeaseDetail>
				<!-- 谁看过我的找活 -->
				<SeenWork v-if="type == 'seenwork'"></SeenWork>
				<!-- 谁看过我的招工 -->
				<SeenRecruit v-if="type == 'seenrecruit'"></SeenRecruit>
				<!-- 发布课程 -->
				<Curlease v-if="type == 'curlease'" @addcha="addcha"></Curlease>
				<!-- 个人设置 -->
				<Setinfo v-if="type == 'setinfo'" @gettype="gettype"></Setinfo>
				<!-- 授课权限 -->
				<Authority v-if="type == 'authority'"></Authority>
				<!-- 课程订单 -->
				<Couorder @gettype="gettype" v-if="type == 'couorder'"></Couorder>
				<!-- 课程订单详情 -->
				<CouorderDetail v-if="type == 'couorderdetail'"></CouorderDetail>
				<!-- 课程审核 -->
				<Examine v-if="type == 'examine'" @gettype="gettype"></Examine>
				<!-- 课程审核详情 -->
				<ExaDetail v-if="type == 'exadetail'" @gettype="gettype" @addcha="addcha"></ExaDetail>
				<!-- 销售订单 -->
				<Sale v-if="type == 'sale'" @gettype="gettype"></Sale>
				<!-- 销售订单详情 -->
				<SaleDetail v-if="type == 'saledetail'"></SaleDetail>
				<!-- 我的课程 -->
				<Mine v-if="type == 'mine'" @gettype="gettype"></Mine>
				<!-- 我的课程详情 -->
				<MineDetail v-if="type == 'minedetail'" @gettype="gettype"></MineDetail>
				<!-- 面试视频 -->
				<Frequency v-if="type == 'frequency'"></Frequency>
				<!-- 问题与反馈 -->
				<Feedback v-if="type == 'feedback'" @gettype="gettype"></Feedback>
				<!-- 问题详情 -->
				<Feedetail v-if="type == 'feedetail'"></Feedetail>
				<!-- 我要反馈 -->
				<Feed v-if="type == 'feed'"></Feed>
				<!-- 反馈记录 -->
				<Feedlist v-if="type == 'feedlist'"></Feedlist>
				<!-- 我的收藏 -->
				<Collect v-if="type == 'collect'"></Collect>
				<!-- 我的钱包 -->
				<Wallet v-if="type == 'wallet'" @gettype="gettype"></Wallet>
				<!-- 我的银行卡 -->
				<Bank v-if="type == 'bank'" @gettype="gettype"></Bank>
				<!-- 我要提现 -->
				<Withdraw v-if="type == 'withdraw'" @gettype="gettype"></Withdraw>
				<!-- 提现记录 -->
				<WithdrawRecord v-if="type == 'withdrawrecord'"></WithdrawRecord>
				<!-- 提现密码 -->
				<Setpass v-if="type == 'setpass'"></Setpass>
				<!-- 收入记录 -->
				<Income v-if="type == 'income'"></Income>
				<!-- 添加银行卡 -->
				<Addbank v-if="type == 'addbank'"></Addbank>
				<!-- 我的积分 -->
				<Integral v-if="type == 'integral'" @gettype="gettype"></Integral>
				<!-- 积分记录 -->
				<IntegralRecord v-if="type == 'integralrecord'"></IntegralRecord>
				<!-- 充值积分 -->
				<IntegralRecharge v-if="type == 'integralrecharge'"></IntegralRecharge>
				<!-- 身份证实名认证	 -->
				<Idcard v-if="type == 'idcard'" @gettype="gettype"></Idcard>
				<!-- 身份证号实名认证	 -->
				<Idnumber v-if="type == 'idnumber'"></Idnumber>
				<!-- 企业认证	 -->
				<Enterprise v-if="type == 'enterprise'"></Enterprise>
				<!-- 发票记录 -->
				<Recordt v-if="type == 'recordt'" @gettype="gettype"></Recordt>
				<!-- 发票记录详情 -->
				<Detailt v-if="type == 'detailt'"></Detailt>
				<!-- 创建抬头 -->
				<Addinvoice v-if="type == 'addinvoice'"></Addinvoice>
				<!-- 抬头管理 -->
				<Manage v-if="type == 'manage'" @gettype="gettype"></Manage>
				<!-- 申请发票 -->
				<Apply v-if="type == 'apply'" @gettype="gettype" @showsub="showsub"></Apply>
				<!-- 任务中心 -->
				<Task v-if="type == 'task'"  @gettype="gettype"></Task>
				<!-- 邀请好友 -->
				<Share v-if="type == 'share'"></Share>
				<!-- 我的招工 -->
				<Recruit v-if="type == 'recruit'"  @gettype="gettype"></Recruit>
				<!-- 我的招工详情 -->
				<RecruitDetail v-if="type == 'recruitetail'"  @gettype="gettype"></RecruitDetail>
				<!-- 已购课程 -->
				<PurList v-if="type == 'purlist'" @gettype="gettype"></PurList>
				<!-- 已购课程详情 -->
				<PurDetail v-if="type == 'purdetail'"></PurDetail>
				<!-- 设置密码 验证手机号-->
				<SetPassword v-if="type == 'setpassword'"  @gettype="gettype"></SetPassword>
				<!-- 设置密码 -->
				<SetPass v-if="type == 'setpassz'"></SetPass>
				<!-- 设置置顶 -->
				<Setplacement v-if="type == 'setplacement'"></Setplacement>

        <!-- 供应商管理 -->
        <adminSupply v-if="type=='adminsupply'" @gettype="gettype" @leftFun="leftFun"></adminSupply>
        <!-- 发布商品 -->
        <sendGoods v-if="type=='sendgoods'" @gettype="gettype"></sendGoods>
			</div>
		</div>
		<!-- 添加章节 -->
		<Chapter v-if="isadd" @closelogin="closelogin"></Chapter>
		<!-- 发票申请提交成功弹窗 -->
		<Submit v-if="issub" @closesub="closesub"></Submit>
		<!-- 添加工作经验弹窗 -->
		<Addproject v-if="project" @closeproject="closeproject"></Addproject>
		<!-- 添加证书弹窗 -->
		<Addcerti v-if="certificate" @closecerti="closecerti"></Addcerti>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';

	import MyLeft from '../my/myleft.vue'; //左边列表
	import MySelt from '../my/myself.vue'; //个人中心
	import Resume from '../my/resume.vue'; //简历名片
	import Basic from '../my/basic.vue'; //简历名片
	import Addproject from '../my/addproject.vue'; //简历名片
	import Addcerti from '../my/certificate.vue'; //简历名片
	import Release from '../my/release.vue'; //发布招工
	import Frequency from '../my/frequency.vue'; //面试视频
	import Setinfo from '../my/setinfo.vue'; //个人设置


	import Authority from '@/components/my/authority/index.vue'; //售课权限
	import Setplacement from '@/components/my/setplacement/index.vue'; //售课权限


	import Bidding from '@/components/my/tender/bidding.vue'; //发布招标
	import Tender from '@/components/my/tender/list.vue'; //发布招标
	import TenderDetail from '@/components/my/tender/detail.vue'; //发布招标

	import Lease from '@/components/my/lease/lease.vue'; //发布租赁
	import Leaselist from '@/components/my/lease/list.vue'; //租赁管理
	import LeaseDetail from '@/components/my/lease/detail.vue'; //租赁管理


	import Collect from '@/components/my/collect/collect.vue'; //收藏

	import SeenWork from '@/components/my/seen/worker.vue'; //谁看过我的找活
	import SeenRecruit from '@/components/my/seen/recruit.vue'; //谁看过我的找活

	import Feedback from '@/components/my/feed/feedback.vue'; //意见反馈
	import Feedetail from '@/components/my/feed/detail.vue'; //问题详情
	import Feed from '@/components/my/feed/index.vue'; //意见反馈
	import Feedlist from '@/components/my/feed/list.vue'; //意见反馈

	import Idcard from '@/components/my/attestation/idcard.vue'; //身份证实名认证
	import Idnumber from '@/components/my/attestation/idnumber.vue'; //身份证号实名认证
	import Enterprise from '@/components/my/attestation/enterprise.vue'; //企业认证

	import Addinvoice from '@/components/my/invoice/add.vue'; //创建抬头
	import Manage from '@/components/my/invoice/manage.vue'; //抬头管理
	import Apply from '@/components/my/invoice/apply.vue'; //申请发票
	import Submit from '@/components/my/invoice/submit.vue'; //发票申请提交成功弹窗

	import Wallet from '@/components/my/wallet/index.vue'; //我的钱包
	import Bank from '@/components/my/wallet/bank.vue'; //我的银行卡
	import Withdraw from '@/components/my/wallet/withdraw.vue'; //我要提现
	import WithdrawRecord from '@/components/my/wallet/record.vue'; //提现记录
	import Setpass from '@/components/my/wallet/setpass.vue'; //提现密码
	import Income from '@/components/my/wallet/income.vue'; //收入记录
	import Addbank from '@/components/my/wallet/addbank.vue'; //添加银行卡

	import Integral from '@/components/my/integral/index.vue'; //我的积分
	import IntegralRecord from '@/components/my/integral/record.vue'; //积分记录
	import IntegralRecharge from '@/components/my/integral/recharge.vue'; //充值积分

	import Curlease from '@/components/my/curriculum/release.vue'; //发布课程
	import Chapter from '@/components/my/curriculum/chapter.vue'; //添加章节

	import Recordt from '@/components/my/receipt/record.vue'; //发票记录
	import Detailt from '@/components/my/receipt/detail.vue'; //发票记录详情

	import Couorder from '@/components/my/course/order.vue'; //课程订单
	import CouorderDetail from '@/components/my/course/order-detail.vue'; //课程订单详情
	import Examine from '@/components/my/course/examine.vue'; //课程审核
	import ExaDetail from '@/components/my/course/exa-detail.vue'; //课程审核详情
	import Sale from '@/components/my/course/sale.vue'; //销售订单
	import SaleDetail from '@/components/my/course/sale-detail.vue'; //销售订单详情
	import Mine from '@/components/my/course/mine.vue'; //销售订单详情
	import MineDetail from '@/components/my/course/minedetail.vue'; //销售订单详情

	import Recruit from '@/components/my/recruit/list.vue'; //我的招工
	import RecruitDetail from '@/components/my/recruit/detail.vue'; //我的招工

	import Task from '@/components/my/task/task.vue'; //任务中心
	import Share from '@/components/my/task/share.vue'; //邀请好友

	import PurList from '@/components/my/purchased/list.vue'; //已购课程
	import PurDetail from '@/components/my/purchased/detail.vue'; //已购课程

	import SetPassword from '@/components/my/password/set.vue'; //已购课程
	import SetPass from '@/components/my/password/setpas.vue'; //已购课程

  import adminSupply from "@/components/my/supply/adminSupply.vue";//供应链管理
  import sendGoods from "@/components/my/supply/sendGoods.vue";//发布商品



	export default {
		components: {
			Top,
			MyLeft,
			MySelt,
			Resume,
			Basic,
			Addproject,
			Addcerti,
			Release,
			Bidding,
			Tender,
			TenderDetail,

			Lease,
			Leaselist,
			LeaseDetail,

			Setinfo,
			Authority,
			Setplacement,
			Frequency,
			Collect,

			SeenWork,
			SeenRecruit,

			Feedback,
			Feedetail,
			Feed,
			Feedlist,

			Idcard,
			Idnumber,
			Enterprise,

			Addinvoice,
			Manage,
			Apply,
			Submit,

			Wallet,
			Bank,
			Withdraw,
			WithdrawRecord,
			Setpass,
			Income,
			Addbank,

			Integral,
			IntegralRecord,
			IntegralRecharge,

			Curlease,
			Chapter,

			Recordt,
			Detailt,

			Couorder,
			CouorderDetail,
			Examine,
			ExaDetail,
			Sale,
			SaleDetail,
			Mine,
			MineDetail,

			Task,
			Share,

			Recruit,
			RecruitDetail,

			PurList,
			PurDetail,

			SetPassword,
			SetPass,

      adminSupply,
      sendGoods
		},
		name: '',
		data() {
			return {
				type: 'myself', //用于判断显示的组件
				isadd: false, //是否显示添加章节组件
				typeone: '', //有2级页面的一级页面名
				issub:false,//是否显示发票申请提交成功弹窗
				project:false,//显示添加项目经验的弹窗
				certificate:false,//显示添加证书的弹窗
			}
		},
    watch:{
       '$route': function() {
         console.log('url-change')
             // 重新渲染页面
             this.$router.go(0);
        }
    },
		created() {
			//从别的页面进个人中心某页面
			this.type = this.$route.query.type ? this.$route.query.type : 'myself';
			//通知顶部栏当前在哪个页面
			Bus.$emit('chosename', 'center')
		},
    mounted(){
      if(this.type=='enterprise'){
         this.leftFun(6);
       }
    },

		methods: {
      // 触发子组件中的事件，二次修改侧边栏选中
      leftFun(e){
        console.log(this.$refs.myleft)
        this.$refs.myleft.changeIndex(e)
      },
			back() {
				this.$router.back()
			},
			/**
			 * 接收组件传参显示对应页面
			 * */
			gettype(e) {
				console.log(e);
				this.type = e.type
				this.typeone = e.typeone
			},
			//添加课程章节
			addcha() {
				this.isadd = true
			},
			//关闭章节
			closelogin() {
				this.isadd = false
			},
			//打开发票提交弹窗
			showsub() {
				this.issub = true
			},
			//关闭发票提交弹窗
			closesub() {
				this.issub = false
			},
			//打开添加经验弹窗
			addpro(){
				this.project = true
			},
			//关闭添加经验弹窗
			closeproject() {
				this.project = false
			},
			//打开添加证书弹窗
			addcer(){
				this.certificate = true
			},
			//关闭添加证书弹窗
			closecerti() {
				this.certificate = false
			},

			//回到个人中心主组件
			backmy(e) {
        console.log(e)
				this.type = e
				this.typeone = ''
				Bus.$emit('backmy')
			}
		},
		filters: {
			fiterype(val) {
				switch (val) {
					case 'resume':
						return '简历名片';
					case 'basic':
						return '编辑基本信息';
					case 'release':
						return '发布招工';
					case 'bidding':
						return '发布招标';
					case 'tender':
						return '招标管理';
					case 'tenderdetail':
						return '详情';
					case 'lease':
						return '发布租赁';
					case 'leaselist':
						return '租赁列表';
					case 'leasedetail':
						return '详情';
					case 'curlease':
						return '发布课程';
					case 'recordt':
						return '发票记录';
					case 'detailt':
						return '发票记录详情';
					case 'setinfo':
						return '个人设置';
					case 'couorder':
						return '课程订单';
					case 'couorderdetail':
						return '课程订单详情';
					case 'examine':
						return '课程审核';
					case 'exadetail':
						return '课程审核详情';
					case 'sale':
						return '销售订单';
					case 'saledetail':
						return '销售订单详情';
					case 'mine':
						return '我的课程';
					case 'minedetail':
						return '详情';
					case 'frequency':
						return '面试视频';
					case 'feedback':
						return '问题与反馈';
					case 'feedetail':
						return '详情';
					case 'feed':
						return '我要反馈';
					case 'feedlist':
						return '反馈记录';
					case 'collect':
						return '我的收藏';
					case 'wallet':
						return '我的钱包';
					case 'bank':
						return '我的银行卡';
					case 'withdraw':
						return '我要提现';
					case 'withdrawrecord':
						return '提现记录'
					case 'setpass':
						return '提现密码';
					case 'income':
						return '收入记录';
					case 'addbank':
						return '添加银行卡';
					case 'integral':
						return '我的积分';
					case 'integralrecord':
						return '积分记录';
					case 'integralrecharge':
						return '充值积分';
					case 'idcard':
						return '实名认证';
					case 'idnumber':
						return '实名认证';
					case 'enterprise':
						return '企业认证';
					case 'addinvoice':
						return '创建抬头';
					case 'manage':
						return '抬头管理';
					case 'apply':
						return '申请发票';
					case 'task':
						return '任务中心';
					case 'share':
						return '邀请好友';
					case 'seenwork':
						return '谁看过我的找活';
					case 'seenrecruit':
						return '谁看过我的招工';
					case 'recruit':
						return '我的招工';
					case 'recruitetail':
						return '我的招工详情';
					case 'purlist':
						return '已购课程';
					case 'purdetail':
						return '已购课程详情';
					case 'setpassword':
						return '验证手机号';
					case 'setpassz':
						return '设置密码';
					case 'authority':
						return '授课权限';
					case 'setplacement':
						return '设置置顶';
          case 'adminsupply':
            	return '供应商管理';
          case 'sendgoods':
              return '发布产品';
					default:
						return '';
				}
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/tab/center.vue